import { type JSX, memo } from "react";
import { useQuery } from "urql";
import Loader from "../../shared/components/Loader";
import { useSelectedIds } from "../components/SelectedIds";
import ShowError from "../components/ShowError";
import CustomPerf from "./CustomPerf";
import Goals from "./Goals";
import MyPerf from "./MyPerf";
import PathGroupPerf from "./PathGroupPerf";
import Stats from "./Stats";
import { type IArgs, type IData, query } from "./query";

function Performance(): JSX.Element {
    const id = useSelectedIds().pmId;
    const [result] = useQuery<IData, IArgs>({
        query,
        variables: {
            id,
        },
        pause: !id,
    });

    if (!id) {
        return <Loader />;
    }
    if (result.fetching) {
        return <Loader />;
    }
    if (result.error) {
        return <ShowError />;
    }
    const data = result.data;
    if (!data.pathMembership) {
        return <div />;
    }
    const hasPathGroup = !!data.pathMembership.pathGroup;
    const hasCustomPerf =
        data.pathMembership.learningPath.leaderboards?.length > 0 ||
        data.pathMembership.learningPath.scoreboards?.length > 0;
    return (
        <>
            <MyPerf data={data} />
            {hasCustomPerf && <CustomPerf data={data} />}
            <Goals data={data} />
            {hasPathGroup && <PathGroupPerf data={data} />}
            <Stats data={data} />
        </>
    );
}

export default memo(Performance);
